export const NONE = 'NONE';
export const X = 'X';
export const O = 'O';
export const OUT_OF_SCOPE = 'OUT_OF_SCOPE';
export const INVALID = 'INVALID';
